import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TitleStrategy } from '@angular/router';
import { Environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AppTitleStrategy extends TitleStrategy {
	title = inject(Title);

	updateTitle(): void {
		this.title.setTitle(Environment.pageTitle);
	}
}
